import React, { useContext } from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Switch
} from '@mui/material';
import FormContext from '../FormContext';

type PropsType = {
    name: string,
    label: string,
    value: boolean,
    variant?: 'switch',
    helperText?: string,
    disabled?: boolean,
    sx?: {[key: string]: string | number },
    onChange: (a: any) => void,
    alignItems?: 'center' | 'flex-start'
};

const BoolField: React.FC<PropsType> = (props) => {
    const {
        name,
        label,
        value,
        variant,
        helperText = '',
        disabled,
        sx,
        onChange,
        alignItems = 'flex-start'
    } = props;

    const formContext = useContext(FormContext);
    const isSubmitting = formContext?.isSubmitting;

    const handleChange = React.useCallback((e) => {
        onChange({ [name]: e.target.checked });
    }, [name, onChange]);

    return (
        <FormControl component="fieldset" variant="standard" sx={{ width: '100%', minWidth: 0 }}>
            <FormGroup>
                <FormControlLabel
                    label={label}
                    disabled={disabled || isSubmitting}
                    sx={{
                        alignItems,
                        width: '100%',
                        mx: 0,
                        '& .MuiCheckbox-root, & .MuiSwitch-root': {
                            mt: alignItems === 'center' ? 0 : -0.25,
                            flexShrink: 0
                        },
                        '& .MuiFormControlLabel-label': {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word'
                        }
                    }}
                    control={
                        variant === 'switch'
                            ? <Switch checked={value} name={name} onChange={handleChange} sx={sx} />
                            : <Checkbox checked={value} name={name} onChange={handleChange} sx={sx} />
                    }
                />
            </FormGroup>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
};

export default BoolField;
